<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <i class="ace-icon fa fa-home home-icon"></i>
        <a href="#/">ダッシュボード</a>
      </li>
      <router-link tag="li" :to="{name: 'gateedit', query: { id: gateId }}">
        <a>ゲート編集</a>
      </router-link>
      <li class="active">ユーザーの関連付けを追加</li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-header">
    <div class="checkbox">
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace userId" checked="checked" @click="addRomoveScorp('userId', 'userId')">
        <span class="lbl">ユーザーID</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace name" checked="checked" @click="addRomoveScorp('name', 'name')">
        <span class="lbl">ユーザー名</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace furigana" checked="checked" @click="addRomoveScorp('furigana', 'furigana')">
        <span class="lbl">ユーザー名ふりがな</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace option1" checked="checked" @click="addRomoveScorp('option1', 'option1')">
        <span class="lbl">備考.1</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace option2" checked="checked" @click="addRomoveScorp('option2', 'option2')">
        <span class="lbl">備考.2</span>
      </label>
      <span class="input-icon search-box">
        <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
        <i class="ace-icon fa fa-search nav-search-icon"></i>
      </span>
      <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
      <button class="btn-cusstom green-btn" type="button" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたユーザーを追加する</button>
      <button class="btn-cusstom black-btn pull-right" type="button" @click="cancel()">ゲート編集画面に戻る</button>
    </div>
  </div><!-- /.page-header -->
  <!-- END MAIN -->
  <div class="page-content">
    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
      {{ errorMessageLogs }}
    </div>
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="scroll-data-content">
        <div class="pull-right">
          <a class="option_button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
            <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
          </a>
        </div>
        <div class="clearfix" style="clear:both">
          <div id="accordion">
            <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
              <div class="panel-body">
                <div class="control-group">
                  <label class="control-label bolder blue display_block">表示項目</label>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_id" type="checkbox" class="ace" disabled checked>
                      <span class="lbl"> ユーザーID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_name" type="checkbox" @click="ShowHideColumn" class="ace" checked value="name" v-model="checkedColumnNames">
                      <span class="lbl"> ユーザー名</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_furigana" type="checkbox" class="ace" @click="ShowHideColumn" value="furigana" v-model="checkedColumnNames">
                      <span class="lbl">ユーザー名ふりがな</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_permistion" type="checkbox" class="ace" @click="ShowHideColumn" value="isAdmin" v-model="checkedColumnNames">
                      <span class="lbl">権限</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_status" type="checkbox" class="ace" @click="ShowHideColumn" value="status" v-model="checkedColumnNames">
                      <span class="lbl"> ステータス</span>
                    </label>
                  </div>
                </div>
                <div class="control-group">
                  <label class="control-label bolder blue display_block">ページことに表示する項目</label>
                  <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                    <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                    {{ pageSize }} 件
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list!=null">
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" v-model="selectAll">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="user_id" class="user_id sorting" @click="sort('userId', 'user_id')" style="word-wrap:break-word">ユーザーID</th>
              <th id="user_name" class="user_name sorting" @click="sort('name', 'user_name')" v-bind:class="{'none': checkColumnShowHide('name')}">ユーザー名</th>
              <th id="user_furigana" class="user_furigana sorting" @click="sort('furigana', 'user_furigana')" v-bind:class="{'none': checkColumnShowHide('furigana')}">ユーザー名ふりがな</th>
              <th id="user_permistion" class="center user_permistion sorting" @click="sort('isAdmin', 'user_permistion')" v-bind:class="{'none': checkColumnShowHide('isAdmin')}">権限</th>
              <th id="user_status" class="center user_status sorting" @click="sort('isValid', 'user_status')" v-bind:class="{'none': checkColumnShowHide('status')}">ステータス</th>
              <th class="center gateStart">開始日時</th>
              <th class="center gateEnd">終了日時</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index">
            <tr v-bind:class="{'selected': rowSelected(item.userId)}" :id="item.userId">
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.userId" v-model="selectedUserId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="user_id" style="word-wrap: break-word">
                {{item.userId}}
              </td>
              <td class="user_name" v-bind:class="{'none': checkColumnShowHide('name')}">
                {{item.name}}
              </td>
              <td class="user_furigana" v-bind:class="{'none': checkColumnShowHide('furigana')}">{{item.furigana}}</td>
              <td class="center user_permistion" v-bind:class="{'none': checkColumnShowHide('isAdmin')}">
                <span v-if="item.isAdmin">管理者</span>
                <span v-else >ユーザー</span>
              </td>
              <td class="center user_status" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="center" style="width:300px">
                <date-picker-before v-bind:item="item" v-on:edited="updateEditStatus()"></date-picker-before>
              </td>
              <td class="center" style="width:300px">
                <date-picker-after v-bind:item="item" v-on:edited="updateEditStatus()"></date-picker-after>
              </td>
            </tr>
          </tbody>
        </table>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace">
                  <span class="lbl"></span>
                </label>
              </th>
              <th>ユーザーID</th>
              <th>ユーザー名</th>
              <th>ユーザー名ふりがな</th>
              <th>権限</th>
              <th>ステータス</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colspan="6">{{messageData}}</td></tr>
          </tbody>
        </table>
    </div><!-- /.row -->
    <div class="row pd-t-10">
      <div class="col-xs-12">
        <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
          <paginate
            :page-count="pages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="handleCurrentChange"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
  <!-- プロフィールModal -->
  <div id="process" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">ゲートの関連付けを追加</h3>
        </div>
        <div class="modal-body">
          <span class="progress-question">チェックしたゲートを追加しますか？</span>
          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
            <div class="progress-bar" :style="progressWidth">
            <span>{{ Math.round(progress) }}%</span>
            </div>
          </div>
          <span class="success-label" v-if="successUser>0">{{countUser}}件中{{successUser}}件を追加しました。</span>
          <div v-if="errorMessage.length>0">
          <span class="error-box-title">追加失敗</span>
          <div class="error-box">
            <template v-for="item in errorMessage">
              <p v-html="item" :key="item"></p>
            </template>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="addUserToGate()">実行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import DatePickerBefore from './DatePickerBefore.vue'
import DatePickerAfter from './DatePickerAfter.vue'
import swal from 'sweetalert'

export default {
  data () {
    return {
      list: null,
      errorMessageLogs: '',
      columnNames: [
        'name',
        'furigana',
        'isAdmin',
        'status'
      ],
      checkedColumnNames: [
        'name'
      ],
      listUserGroup: null,
      scorp: ['userId', 'name', 'furigana', 'option1', 'option2'],
      gateId: '',
      total: 0,
      pages: 0,
      error: null,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      pageState: {
        selected: true,
        edited: false
      },
      selected: 100,
      progress: 0,
      selectedUserId: [],
      existUserId: [],
      success: false,
      loading: false,
      isDisabled: false,
      errorMessage: [],
      successUser: 0,
      errorName: '',
      checkFirstLoad: 0,
      countUser: 0,
      exeCount: 0,
      percent: 0,
      messageData: 'データー取得中'
    }
  },
  components: {
    DatePickerBefore: DatePickerBefore,
    DatePickerAfter: DatePickerAfter
  },
  // countUserとはチェックしたアイテム数。
  // exeCountとはAPI実行回数、デフォルトの値は０です。
  // 一回APIを実行が終わるとexeCount に１をプラスする。
  // 全部APIを実行が終わるとexeCount の値は０にリセットする。
  // exeCount<countUserの時は次のAPI実行。
  // exeCount===countUserの時(全部APIを実行が終わったの時)は変数の値リセットする。
  watch: {
    'checkedColumnNames': 'updateChecked',
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countUser) {
        var notBefore = $('#notBeforeDate' + vm.removeSpecialSymboy(vm.selectedUserId[newVal])).val() + ' ' + $('#notBeforeTime' + vm.removeSpecialSymboy(vm.selectedUserId[newVal])).val()
        var notAfter = $('#notAfterDate' + vm.removeSpecialSymboy(vm.selectedUserId[newVal])).val() + ' ' + $('#notAfterTime' + vm.removeSpecialSymboy(vm.selectedUserId[newVal])).val()
        notBefore = vm.converTimestamp(notBefore)
        notAfter = vm.converTimestamp(notAfter)
        vm.addUser(vm.selectedUserId[newVal], notBefore, notAfter, vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countUser) {
        this.exeCount = 0
        this.success = true
        this.selectedUserId = []
        this.pageState.edited = false
      }
    }
  },
  created () {
    if (typeof localStorage.pageSizeGateUserAdd === 'undefined') {
      localStorage.setItem('pageSizeGateUserAdd', 25)
      this.selected = localStorage.pageSizeGateUserAdd
    } else {
      this.selected = localStorage.pageSizeGateUserAdd
    }
    if (typeof localStorage.gateUserAddSortKey === 'undefined') {
      localStorage.setItem('gateUserAddSortKey', 'userId')
    }
    if (typeof localStorage.gateUserAddSortName === 'undefined') {
      localStorage.setItem('gateUserAddSortName', 'desc')
    }
    if (typeof localStorage.checkedGateUserAdd === 'undefined') {
      localStorage.setItem('checkedGateUserAdd', this.checkedColumnNames)
    } else {
      var tempData = []
      this.columnNames.forEach(function (item) {
        if (localStorage.checkedGateUserAdd.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
    this.getList()
    this.fetchData()
  },
  beforeRouteLeave (to, from, next) {
    if (this.selectedUserId.length > 0) {
      this.pageState.selected = false
    } else {
      this.pageState.selected = true
    }
    // フォームを送信した場合などに離脱とみなさないようにするため。
    if (this.pageState.selected && !this.pageState.edited) {
      $(window).off('beforeunload')
      return next()
    }
    swal({
      text: '編集中のデータがあります。このページから移動してもよろしいですか?',
      buttons: {
        cancel: 'キャンセル',
        confirm: 'はい、移動します'
      },
      dangerMode: true
    }).then((e) => {
      if (e) {
        $(window).off('beforeunload')
        next()
      } else {
        next(false)
      }
    })
  },
  mounted () {
    var vm = this
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
    window.onbeforeunload = function () {
      return '編集中のデータがあります。このページから移動してもよろしいですか?'
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAll: {
      get: function () {
        return this.list ? (this.selectedUserId.length) >= this.list.length : false
      },
      set: function (value) {
        var selectedUserId = []
        if (value) {
          this.list.forEach(function (item) {
            selectedUserId.push(item.userId)
          })
        }
        this.selectedUserId = selectedUserId
      }
    }
  },
  methods: {
    updateEditStatus () {
      this.pageState.edited = true
    },
    updateChecked () {
      localStorage.setItem('checkedGateUserAdd', this.checkedColumnNames)
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedGateUserAdd.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    // １ページに表示する項目数
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizeGateUserAdd', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.pages = 0
      this.getList()
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('チェックしたユーザーを追加しますか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successUser = 0
      this.countUser = 0
    },
    cancel () {
      this.$router.push({name: 'gateedit', query: { id: this.gateId }})
    },
    fetchData () {
      var data = this.$route.query
      this.gateId = data.id
      this.getInforUserGroup(this.gateId)
    },
    getInforUserGroup (gateId) {
      var vm = this
      this.$http.get(Config.GATES_PASSAGE_API + '?gateId=' + encodeURIComponent(gateId))
        .then(response => {
          vm.listUserGroup = response.body.passages
        })
        .catch((error) => {
          console.log(error)
        })
    },
    rowSelected (userId) {
      if (jQuery.inArray(userId, this.selectedUserId) !== -1) {
        return true
      } else {
        return false
      }
    },
    rowSelectedExistUser (userId) {
      if (jQuery.inArray(userId, this.existUserId) !== -1) {
        return true
      } else {
        return false
      }
    },
    addUser (userId, notBefore, notAfter, percent, i) {
      this.$http.post(Config.GATES_PASSAGE_API, {gateId: this.gateId, userId: userId, notBefore: notBefore, notAfter: notAfter})
        .then(response => {
          this.loading = false
          this.progress += percent
          this.successUser += 1
          this.exeCount++
        })
        .catch((error) => {
          this.loading = false
          this.progress += percent
          switch (error.status) {
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 409:
              this.errorName = '通行権限が重複しています。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = userId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCount++
        })
    },
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    },
    addUserToGate () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedUserId.length > 0) {
        this.countUser = this.selectedUserId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedUserId.length)
        var notBefore = $('#notBeforeDate' + vm.removeSpecialSymboy(this.selectedUserId[0])).val() + ' ' + $('#notBeforeTime' + vm.removeSpecialSymboy(this.selectedUserId[0])).val()
        var notAfter = $('#notAfterDate' + vm.removeSpecialSymboy(this.selectedUserId[0])).val() + ' ' + $('#notAfterTime' + vm.removeSpecialSymboy(this.selectedUserId[0])).val()
        notBefore = vm.converTimestamp(notBefore)
        notAfter = vm.converTimestamp(notAfter)
        vm.addUser(this.selectedUserId[0], notBefore, notAfter, vm.percent, 0)
      } else {
        alert('少なくてもユーザーを１つ選んでください。')
      }
    },
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    search () {
      this.loading = true
      this.errorMessageLogs = ''
      if (this.scorp.length > 0) {
        $('#simple-table').find('tr.detail-row').removeClass('open')
        window.scrollTo(0, 0)
        this.listQuery.currPage = 1
        this.pages = 0
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.USERS_LIST_API + '?limit=' + localStorage.pageSizeGateUserAdd + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.gateUserAddSortName + ':' + localStorage.gateUserAddSortKey + '&isValid=true')
          .then(response => {
            if (response.body.maxRecords > 0) {
              this.loading = false
              this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeGateUserAdd)
              this.list = response.body.users
              console.log(response)
            } else {
              this.loading = false
              this.list = null
              this.pages = 0
              this.messageData = '該当するデーターがありません。'
            }
          })
          .catch((error) => {
            this.loading = false
            this.list = null
            this.pages = 0
            this.messageData = '該当するデーターがありません。'
            switch (error.status) {
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('gateUserAddSortName', 'desc')
        localStorage.setItem('gateUserAddSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('gateUserAddSortName', 'asc')
        localStorage.setItem('gateUserAddSortKey', sortkey)
      }
      this.getList()
    },
    handleCurrentChange (val) {
      this.selectedUserId = []
      this.listQuery.currPage = val
      this.getList()
      window.scrollTo(0, 0)
    },
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    getList () {
      this.loading = true
      this.errorMessageLogs = ''
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      this.$http.get(Config.USERS_LIST_API + '?limit=' + localStorage.pageSizeGateUserAdd + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.gateUserAddSortName + ':' + localStorage.gateUserAddSortKey + '&isValid=true')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeGateUserAdd)
            this.list = response.body.users
            console.log(response)
          } else {
            this.loading = false
            this.list = null
            this.pages = 0
            this.messageData = '該当するデーターがありません。'
          }
        })
        .catch((error) => {
          this.loading = false
          this.list = null
          this.pages = 0
          this.messageData = '該当するデーターがありません。'
          switch (error.status) {
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
.table-detail .profile-info-name{
  width: 195px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.datepicker {
  margin-top: 35px;
}
</style>



// WEBPACK FOOTER //
// src/views/gate/GateUserAdd.vue